<script lang="ts">
	import Logo from '$lib/components/partials/Logo.svelte'
	import HeaderMenu from '$lib/components/common/menu/HeaderMenu.svelte'
	import HeroMenu from '$lib/components/common/menu/HeroMenu.svelte'
	import InfoMenu from '$lib/components/common/menu/InfoMenu.svelte'
	import AccountMenu from '$lib/components/common/menu/AccountMenu.svelte'
	import SearchbarSimple from '$lib/modals/search/SearchbarSimple.svelte'
	import { getUniverseInfo, is_set_array } from '$lib/js/helpers'
	import {
		storeCartItems,
		storeMiniCartModal,
		storeHeroMenu,
		storeLoggedUser,
		storeInfoMenu,
	} from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { page } from '$app/stores'
	import { getContextScope } from '$lib/js/helpers/i18n'

	$: innerWidth = 0

	const scope = getContextScope()

	/* Cart items num */
	let cartItems = 0

	$: if (is_set_array($storeCartItems)) {
		cartItems = 0

		for (const i in $storeCartItems) {
			cartItems += $storeCartItems[i].cart_qty
		}
	} else {
		cartItems = 0
	}

	$: universe_info = getUniverseInfo(
		$page.data?.universes_menu?.universes,
		$page.data?.category?.url_path?.split('/')[1]
	)
	$: univClass = universe_info ? 'universe' : ''

	function openCart() {
		$storeMiniCartModal = true
	}

	function accountActions(e: Event) {
		if (innerWidth <= 768 && $storeLoggedUser === true) {
			e.preventDefault()
			$storeInfoMenu = 'account'
		} else if (innerWidth > 768 && $storeLoggedUser === true) {
			$storeInfoMenu = $storeInfoMenu === '' ? ($storeInfoMenu = 'account') : ''
		}
	}
</script>

<svelte:window bind:innerWidth />

<div class="site-header {univClass}">
	<div class="container site-header__wrapper">
		<div class="site-header__logo">
			{#if universe_info}
				{#if $page.data.mobile === false || innerWidth > 768}
					<a
						style="--univ-sec: {universe_info.color_sec}"
						class="universe-link"
						href="/{scope}/u/{universe_info.name}"
					>
						<img
							src="/images/universes/logos/{universe_info.name}.svg"
							alt="Bixoto {universe_info.name}"
							title="Bixoto {universe_info.name}"
						/>
					</a>
				{/if}
			{/if}
		</div>

		<div class="site-header__right">
			<div class="site-header__inner">
				<div class="site-header__left">
					{#if $page.data.mobile === true || innerWidth <= 768}
						<button
							class="all-cats"
							on:click={() => ($storeHeroMenu = 'mobile')}
							aria-label={$t`All categories`}
						>
							<span class="icon icon-menu"></span>
						</button>
					{:else if !universe_info}
						<a class="bixoto" href="/{scope}" aria-label={$t`Home`}><Logo /></a>
					{/if}
				</div>

				{#if !universe_info}
					{#if $page.data.mobile === true || innerWidth <= 768}
						<a class="bixoto" href="/{scope}" aria-label={$t`Home`}>
							<Logo />
						</a>
					{/if}
				{/if}

				{#if $page.data.mobile === false || innerWidth > 768}
					<div
						role="searchbox"
						tabindex="0"
						class="searchbar"
						on:mouseenter={() => ($storeHeroMenu = '')}
					>
						<SearchbarSimple />
					</div>
				{/if}

				{#if universe_info}
					{#if $page.data.mobile === true || innerWidth <= 768}
						<a
							style="--univ-sec: {universe_info.color_sec}"
							class="universe-link"
							href="/{scope}/u/{universe_info.name}"
						>
							<img
								src="/images/universes/logos/{universe_info.name}.svg"
								alt="Bixoto {universe_info.name}"
								title="Bixoto {universe_info.name}"
							/>
						</a>
					{/if}
				{/if}

				<button class="site-header__buttons" on:mouseleave={() => ($storeInfoMenu = '')}>
					<a
						href="/{scope}/customer/account/login"
						rel="external"
						on:click={(e) => accountActions(e)}
						on:mouseenter={(e) => accountActions(e)}
						class="account"
						aria-label={$t`Account`}
					>
						<span class="icon icon-account"></span>

						{#if $storeLoggedUser === true}
							<span class="logged_in"></span>
						{/if}
					</a>

					{#if $page.data.mobile === false || innerWidth > 768}
						<button
							class="help"
							aria-label={$t`Help`}
							on:mouseenter={() => ($storeInfoMenu = 'info')}
							on:click={() => ($storeInfoMenu = 'info')}
						>
							<span class="icon icon-help"></span>
						</button>
					{/if}

					<button
						class="cart"
						on:click={() => openCart()}
						on:mouseenter={() => ($storeInfoMenu = '')}
						aria-label="Minicart"
					>
						<span class="icon icon-cart"></span>
						<span class="alerts-num">{cartItems}</span>
					</button>

					{#if $storeInfoMenu === 'info'}
						<InfoMenu />
					{:else if $storeInfoMenu === 'account'}
						<AccountMenu />
					{/if}
				</button>
			</div>

			<HeaderMenu>
				<HeroMenu />
			</HeaderMenu>
		</div>
	</div>
</div>

<style lang="scss">
	.universe-link {
		display: flex;
		line-height: 1;

		img {
			height: 36px;
			object-fit: contain;

			@media (min-width: 769px) {
				height: auto;
				width: 120px;
			}
		}
	}

	.site-header {
		position: sticky;
		top: 0;
		z-index: 9;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		box-shadow: 0 4px 20px 10px rgba(0, 0, 0, 0.12);
		background: white;

		@media (min-width: 769px) {
			height: 100px;
		}

		&.universe {
			.site-header {
				&__wrapper {
					display: flex;
					align-items: center;
				}

				&__right {
					flex-grow: 1;
				}
			}
		}

		.all-cats {
			transition: all linear 0.125s;
			font-weight: 700;
			padding-left: 2px;
			transform: scaleX(-1);

			.icon {
				display: inline-block;
				font-size: 21px;
				color: black;
			}
		}

		&__logo {
			@media (max-width: 768px) {
				display: none;
			}
		}

		&__wrapper {
			width: calc(100% - 40px);
			padding: 0 20px;

			@media (max-width: 768px) {
				box-shadow: 0 4px 20px 10px rgba(0, 0, 0, 0.12);
			}
		}

		&__inner {
			padding: 8px 0 5px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			@media (min-width: 769px) {
				padding: 10px 0 5px;
			}

			.universe-link {
				@media (min-width: 769px) {
					display: none;
				}
			}
		}

		&__left {
			display: flex;

			@media (max-width: 768px) {
				width: 73px;
			}

			a {
				display: flex;
				width: 100px;

				@media (min-width: 769px) {
					width: 130px;
				}
			}

			.all-cats {
				@media (min-width: 769px) {
					display: none;
				}
			}
		}

		.searchbar {
			display: none;
			flex-grow: 1;
			position: relative;
			margin: 0 80px 0 43px;

			@media (min-width: 769px) {
				display: block;
			}
		}

		&__buttons {
			position: relative;
			display: flex;
			align-items: center;

			a,
			button {
				&:hover {
					span {
						color: var(--main);
					}
				}
			}

			a,
			button {
				display: inline-block;
				margin-right: 15px;

				&.account {
					position: relative;

					.logged_in {
						width: 16px;
						height: 16px;
						display: block;
						background: var(--secondary);
						border-radius: 16px;
						position: absolute;
						top: 23px;
						right: -6px;
						border: 2px solid var(--grey);
					}
				}
			}

			.icon {
				transition: all linear 0.125s;
				font-size: 28px;
				color: black;

				@media (min-width: 769px) {
					font-size: 30px;
				}
			}

			.help {
				@media (max-width: 768px) {
					display: none;
				}
			}

			.cart {
				position: relative;
				margin-left: 12px;
				margin-right: 0;

				&:hover {
					.icon-cart {
						@media (max-width: 768px) {
							color: black;
						}
					}
					.alerts-num {
						color: white;

						@media (min-width: 769px) {
							transform: translateY(-3px);
						}
					}
				}
			}

			.alerts-num {
				position: absolute;
				top: 8px;
				right: 18px;
				background-color: var(--main);
				color: white;
				width: 28px;
				height: 28px;
				border-radius: 22px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 700;
				font-size: 16px;
				transition: all linear 0.125s;
				border: 2px solid #fff;
			}
		}
	}
</style>
